//#if UNITY_ANDROID
//using Assets.SimpleAndroidNotifications;
//#endif
//
//using System;
//using System.Collections;
//using System.Collections.Generic;
//using UnityEngine;

import {TimeSpan} from "../Utils/Unity/TimeSpan";
import {Time} from "../Utils/Unity/Time";

const APPLICATION_NAME = "Homo Evolution"; // XXX: temporary here... move this

export class NotificationsManager {
    static minTime = new TimeSpan(9, 0, 0);
    static maxTime = new TimeSpan(23, 59, 59);

    timeWasFixed = false;

    Start() {
        this.clearAll();

//        while (Core.Localizator == null)
//        {
//            yield return null;
//        }
//
//        pushMissions = Core.Localizator.Get("push_mission");
//        pushMoneyBox = Core.Localizator.Get("push_fullbank");
//        pushDay1 = Core.Localizator.Get("push_24h");
//        pushDay2 = Core.Localizator.Get("push_48h");
//        pushSpins = Core.Localizator.Get("push_spin");
    }

    clearAll() {
        //#if UNITY_EDITOR
        //
        //#elif UNITY_IOS
        //        UnityEngine.iOS.NotificationServices.CancelAllLocalNotifications();
        //#elif UNITY_ANDROID
        //        NotificationManager.CancelAll();
        //#endif
    }

    OnApplicationPause(pause = false) {
        if (pause) {
            this.updateNotifications();
        }
        else {
            this.clearAll();
        }
    }

    OnApplicationQuit() {
        this.updateNotifications();
    }


    isMissionInProgress = 0;
    missionSecondsLeft = 0;
    moneyBoxStoredSeconds = 0;
    secondsBeforeAllSpinsRestore = 0;
    slotsAvailable = false;
    pushMissions = "";
    pushMoneyBox = "";
    pushDay1 = "";
    pushDay2 = "";
    pushSpins = "";

    updateTimer = 0;

    Update() {
        this.updateTimer += Time.deltaTime;
        if (updateTimer < 2) return;
        this.updateTimer = 0;

        if (!Core.GameData) return;
        if (!Core.Player) return;
        if (!Core.Player.PlanetsSave) return;
        if (!Core.GameData.Missions) return;
        if (!Core.Player.PlanetsSave.CurrentPlanet) return;

        this.isMissionInProgress = Core.Player.Missions.IsInProgress();

        if (this.isMissionInProgress) {
            let activeMission = Core.Player.Missions.missionInProgress;
            let missionData = Core.GameData.Missions.GetMission(activeMission.missionId);

            if (missionData) {
                if (this.isMissionInProgress) {
                    let timer = Core.Player.Timers.GetTimerById(activeMission.timerId);
                    this.missionSecondsLeft = timer ? timer.SecondsLeft : 0;
                }
            }
            else {
                this.isMissionInProgress = false;
            }
        }

        let moneyBoxUpgradeProgress = Core.Player.PlanetsSave.GetUpgradeProgress(UpgradeType.MoneyBox);
        this.moneyBoxStoredSeconds = Core.GameData.Upgrades.UpgradeByType(UpgradeType.MoneyBox).TotalValue(moneyBoxUpgradeProgress.upgradeIndex);

        this.slotsAvailable = Core.Player.PlanetsSave.collection.Count >= Core.GameData.Slots.availableFromCollectionSize;

        if (this.slotsAvailable) {
            this.secondsBeforeAllSpinsRestore = Math.Ceil((Core.Player.MaxSpinsNumber - Core.Player.SpinsNumber) / Core.GameData.Slots.restoreSpinsNumberByTime) * Core.GameData.Config.spinsRestorePeriod;
        }
    }

    updateNotifications() {
        this.clearAll();

//        Debug.Log("NotificationsManager: Clear all notifications");

        this.updateMoneyBoxNotification();
        if (!this.timeWasFixed) this.updateMissionNotification();
        if (!this.timeWasFixed) this.updateSpinsNotification();
        if (!this.timeWasFixed) this.updateComebackNotifications();

        //setTestNotification();
    }

    updateSpinsNotification() {
//        Debug.Log("NotificationsManager: Update Money Box Notifications");

        if (this.slotsAvailable && this.secondsBeforeAllSpinsRestore > 60) {
            this.secondsBeforeAllSpinsRestore += 40;
            let completeTime = new Date(Date.now() + this.secondsBeforeAllSpinsRestore * 1000);
            let fixedCompleteTime = this.checkForNight(completeTime);
            let wait = fixedCompleteTime - Date.now();

//            Debug.Log("NotificationsManager: Set spins notification to " + fixedCompleteTime.ToShortDateString() + " " + fixedCompleteTime.ToShortTimeString() + " " + wait.TotalSeconds);

            this.SendNotification(wait, APPLICATION_NAME, this.pushSpins);
        }
    }

    setTestNotification() {
//        this.SendNotification(new TimeSpan(0, 0, 20), APPLICATION_NAME, "Test notification");
    }

    updateMoneyBoxNotification() {
//        Debug.Log("NotificationsManager: Update Money Box Notifications");

        let completeTime = new Date(Date.now() + this.moneyBoxStoredSeconds * 1000);
        let fixedCompleteTime = this.checkForNight(completeTime);
        let wait = fixedCompleteTime - Date.now();

//        Debug.Log("NotificationsManager: Set moneybox notification to " + fixedCompleteTime.ToShortDateString() + " " + fixedCompleteTime.ToShortTimeString() + " " + wait.TotalSeconds);

        SendNotification(wait, APPLICATION_NAME, this.pushMoneyBox);
    }

    updateMissionNotification() {
//        Debug.Log("NotificationsManager: Update Mission Notifications");

        if (this.isMissionInProgress) {
            let completeTime = new Date(Date.now() + this.missionSecondsLeft * 1000);
            let fixedCompleteTime = this.checkForNight(completeTime);
            let wait = fixedCompleteTime - Date.now();

//            Debug.Log("NotificationsManager: Set mission notification to " + fixedReadyTime.ToShortDateString() + " " + fixedReadyTime.ToShortTimeString() + " " + wait.TotalSeconds);

            SendNotification(wait, APPLICATION_NAME, this.pushMissions);
        }
    }

    updateComebackNotifications() {
//        Debug.Log("NotificationsManager: Update Comeback Notifications");

        let day1Date = this.checkForNight(new Date(Date.now() + 3600 * 24 * 1000));
        let day2Date = this.checkForNight(new Date(Date.now() + 3600 * 24 * 2 * 1000));

        let wait1 = day1Date - Date.now();
        let wait2 = day2Date - Date.now();

//        Debug.Log("NotificationsManager: Set comeback1 notification to " + day1Date.ToShortDateString() + " " + day1Date.ToShortTimeString() + " " + wait1.TotalSeconds);
//        Debug.Log("NotificationsManager: Set comeback2 notification to " + day2Date.ToShortDateString() + " " + day2Date.ToShortTimeString() + " " + wait2.TotalSeconds);

        SendNotification(wait1, APPLICATION_NAME, this.pushDay1);
        SendNotification(wait2, APPLICATION_NAME, this.pushDay2);
    }

    checkForNight(date) {
        this.timeWasFixed = false;

        let time = new TimeSpan(date.getHours(), date.getMinutes(), date.getSeconds());
        let fixedDate = new Date(date.getTime());

        if (time < this.minTime) {
            fixedDate.setHours(this.minTime.Hours);
            fixedDate.setMinutes(this.minTime.Minutes);
            fixedDate.setSeconds(this.minTime.Seconds);
            this.timeWasFixed = true;
        }

        /*if (time > maxTime)
        {
            var topTime = new TimeSpan(24, 0, 0);
            fixedDate = fixedDate.Add(topTime - time + minTime);
        }*/

        return fixedDate;
    }

    SendNotification(wait, title, body) {
        console.log("NOTIFICATION:", wait.TotalSeconds, title, body);
    }
}
